(function ($) {
  "use strict";

  /*---- Variables ---------------------------------------*/
  var $window = $(window);
  var $body = $('html, body');
  var $showroomContainer = $('#js-showroom-container');
  var $showroomList = $('#js-showroom-list');
  var $navCarsWrapper = $('#js-showroom-nav-wrapper');
  var $navCars = $('#js-showroom-nav');
  var $menuCars = $('#js-showroom-menu');
  var $links = $menuCars.find('a');
  var headerHeight = $('#js-header').height();
  var sections = [];
  // positions values
  var limitStart, limitEnd;
  var scroll = $window.scrollTop();
  var showroomListHeight = $showroomList.height();
  var menuCarsTop = $navCarsWrapper.offset().top;
  var menuCarsLeft = $showroomContainer.offset().left + $showroomContainer.width() - $navCars.width();
  var navWrapperWidth = $navCarsWrapper.width();

  function throttle(callback,delay) {
    var context, timer ,args;
    var last = 0;
    return function () {
      context = this;
      var now = +new Date();
      args = arguments;
      if (last && now < last + delay) {
        clearTimeout(timer);
        timer = setTimeout(function () {
          last = now;
          callback.apply(context, args);
        }, delay);
      } else {
        last = now;
        callback.apply(context, args);
      }
    };
  }

  function updateValues() {
    scroll = $window.scrollTop();
    showroomListHeight = $showroomList.height();
    menuCarsTop = $navCarsWrapper.offset().top;
    menuCarsLeft = $showroomContainer.offset().left + $showroomContainer.width() - $navCarsWrapper.width();
    navWrapperWidth = $navCarsWrapper.width();
    limitStart = scroll + headerHeight;
    limitEnd = scroll + $menuCars.height() + headerHeight;
    $navCars.css('width', navWrapperWidth + 'px');
    if($navCars.hasClass('is-fixed')) {
      $navCars.css({
        'transform' : 'translateX('+ menuCarsLeft.toFixed(0) +'px)',
        '-webkit-transform' : 'translateX('+ menuCarsLeft.toFixed(0) +'px)',
        '-moz-transform' : 'translateX('+ menuCarsLeft.toFixed(0) +'px)',
        '-ms-transform' : 'translateX('+ menuCarsLeft.toFixed(0) +'px)'
      });
    }
  }

  if($window.width() >= 645) {
    /*---- Init ---------------------------------------*/
    $navCarsWrapper.css('height', showroomListHeight+'px');

    /*---- Functions ---------------------------------------*/
    $links.each(function() {
      sections.push($(this).attr('href').substring(1, $(this).attr('href').length));
    });


    /*---- Events ---------------------------------------*/
    $links.bind('click', function(e) {
      e.preventDefault();
      $links.removeClass('is-active');
      $(this).addClass('is-active');
      var target = $('' + $(this).attr('href') + '').offset().top - headerHeight;
      $body.stop().animate({
        scrollTop: target
      }, 1000);
    });

    $window.scroll(function() {
      scroll = $(this).scrollTop();
      limitStart = scroll + headerHeight;
      limitEnd = scroll + $menuCars.height() + headerHeight;
      if(limitStart >= menuCarsTop) {
        $navCars.removeClass('is-bottom');
        $navCars.addClass('is-fixed');
        $navCars.css('width', navWrapperWidth + 'px');
        $navCars.css({
          'transform' : 'translateX('+ menuCarsLeft.toFixed(0) +'px)',
          '-webkit-transform' : 'translateX('+ menuCarsLeft.toFixed(0) +'px)',
          '-moz-transform' : 'translateX('+ menuCarsLeft.toFixed(0) +'px)',
          '-ms-transform' : 'translateX('+ menuCarsLeft.toFixed(0) +'px)'
        });
      } else {
        $navCars.removeClass('is-fixed');
        $navCars.removeClass('is-bottom');
        $navCars.attr('style', ' ');
      }
      var limitNavHeight = $navCarsWrapper.offset().top + $navCarsWrapper.height();
      if(limitEnd >= limitNavHeight) {
        $navCars.removeClass('is-fixed');
        $navCars.attr('style', ' ');
        $navCars.addClass('is-bottom');
      }

      // ajout de la class active selon la section
      for(var i in sections) {
        var section = $('#'+ sections[i]);
        var sectionOffset = section.offset().top - $window.height()/2;
        if(scroll > sectionOffset) {
          var id = sections[i];
          $links.removeClass('is-active');
          $("a[href='#"+ id +"']").addClass('is-active');
        }
      }

    });

    $window.resize(function () {
      updateValues();
      if($(this).width() > 641) {
      } else {

      }
    });

  } else {
    var $btnShowBrands = $('#js-show-brands');

    $btnShowBrands.bind('click', function(e) {
      e.preventDefault();
      $(this).toggleClass('is-active');
      $menuCars.stop().slideToggle();
    });

    $links.bind('click', function(e) {
      e.preventDefault();
      $links.removeClass('is-active');
      $(this).addClass('is-active');
      var target = $('' + $(this).attr('href') + '').offset().top - headerHeight;
      $body.stop().animate({
        scrollTop: target
      }, 1000);
    });
  }



})(jQuery);